import "../styles/index.scss";
import {
    drawImageScaled,
    getImageFromSelectedArea,
    drawImageBoundary,
    drawLine,
    drawDot,
    onFileChanged,
    cornerPointsRequest,
    drawImage,
    scale, drawImageBoundaryScaled, closestDot, getClosestPoint,
    selectTool
} from "./helpers/helpers.js";

import { mouseMovePenTool, resetLastCoordinates } from './helpers/eventHandlers.js';

import { DOM_HTML, cornerDetectionUrl } from './constants/constants';


export class ReceiptProcessor {
    constructor(settings) {

    }

    mount(){
        /**
    * Mount to DOM 
    */
        const mountPoint = document.querySelector('#receipt-uploader');

        if(!mountPoint){
            console.log("err: Make sure an element with `receipt-uploader` id exists! ")
            return false;
        }

        let uploaderFragment = document.createRange().createContextualFragment(DOM_HTML);
        mountPoint.appendChild(uploaderFragment);

        const loaderDiv = document.querySelector("#loader");
        loaderDiv.classList.add('hide-loader');

        const ImageDisplayerCanvas = document.getElementById("ImageDisplayer");
        const OriginalCanvas = document.getElementById("OriginalCanvas");
        const CropCanvas = document.getElementById("CropCanvas");
        const ResultCanvas = document.getElementById("ResultCanvas");
        const LoadFileBtn = document.getElementById("LoadFileBtn");
        const ZoomInBtn = document.getElementById("ZoomInBtn");
        const buttonPen = document.querySelector(".btn-pen");
        const buttonCrop = document.querySelector(".btn-crop");


        let points = [];
        let img = {};
        // drawDot({ x: 100, y: 100 }, ImageDisplayerCanvas, "#000");
        let centerShift = Object;
        let ratio = Number;
        let currentScale = 1;
        let tempDots = [];
        let closestIndex = Number;
        let clickedPosition = {};
        let imageReady = false;

        const testPoints = [
            { x: 182, y: 182 },
            { x: 413, y: 182 },
            { x: 413, y: 92 },
            { x: 182, y: 92 },
        ];

        let mouseDown = false;

        LoadFileBtn.onchange = e => {
            if (imageReady == false) {
                loaderDiv.classList.remove('hide-loader');
            }
            const files = event.target.files || event.dataTransfer.files;

            if (files && files[0]) {
                let filename = files[0].name;

                if (filename && filename.lastIndexOf('.') <= 0) {
                    return;
                }
            }
            const file = files[0];
            // add file to form for sending to server
            const formData = new FormData();
            formData.append('receipt', file);

            //send request to server for points
            cornerPointsRequest(cornerDetectionUrl, formData)
                .then(result => {
                    // mount image on canvas
                    drawImage(result.image, OriginalCanvas);
                    points = [
                        { x: result.points[0], y: result.points[1] },
                        { x: result.points[2], y: result.points[3] },
                        { x: result.points[4], y: result.points[5] },
                        { x: result.points[6], y: result.points[7] }
                    ];

                    drawImageScaled(result.image, ImageDisplayerCanvas).then(result => {
                        ratio = result.ratio;
                        img = result.img;
                        centerShift = result.centerShift;
                        imageReady = true;
                        loaderDiv.classList.add('hide-loader');
                        drawImageBoundaryScaled(points, CropCanvas, result.ratio, result.img);
                        // drawImageBoundary(points, OriginalCanvas, result.ratio, result.img);
                        // drawImageBoundary(testPoints, ImageDisplayerCanvas,result.ratio);
                        // getImageFromSelectedArea(points, ImageDisplayerCanvas, OriginalCanvas, ResultCanvas);
                    });

                });
        };

        let newScale = 2;
        ZoomInBtn.onclick = e => {

            // currentScale = newScale;
            newScale += 0.5;
            scale(newScale, currentScale, ImageDisplayerCanvas, OriginalCanvas);

        };

        CropBtn.onclick = e => {
            getImageFromSelectedArea(points, ImageDisplayerCanvas, OriginalCanvas, ResultCanvas, ratio, currentScale);
        };

        function cropperTool() {
            selectTool('btn-crop');

            function downHandler(e) {
                e.preventDefault();
                e.stopPropagation();
                tempDots = [...points];

                let positionX = Number;
                let positionY = Number;
                const startX = e.targetTouches ? e.targetTouches[0].pageX : e.pageX;
                const startY = e.targetTouches ? e.targetTouches[0].pageY : e.pageY;

                if (window.TouchEvent && (e instanceof TouchEvent)) {
                    const rect = e.target.getBoundingClientRect();
                    positionX = e.touches[0].clientX - rect.x;
                    positionY = e.touches[0].clientY - rect.y;
                } else {
                    positionX = e.offsetX;
                    positionY = e.offsetY;
                }

                clickedPosition = {
                    x: positionX,
                    y: positionY
                };


                if (e.touches) {
                    let rect = e.target.getBoundingClientRect();
                    positionX = e.touches[0].clientX - rect.x;
                    positionY = e.touches[0].clientY - rect.y;
                }
                const centerShiftX = (ImageDisplayerCanvas.width - img.width * ratio) / 2;
                const centerShiftY = (ImageDisplayerCanvas.height - img.height * ratio) / 2;
                const scaledDots = points.map(d => ({ x: (d.x * ratio) + centerShiftX, y: (d.y * ratio) + centerShiftY }));
                const result = closestDot(scaledDots, clickedPosition.x, clickedPosition.y);
                closestIndex = result.closestIndex;
                // console.log('closest index', closestIndex)
                mouseDown = true;
            }

            function moveHandler(e) {
                e.preventDefault();
                e.stopPropagation();
                let positionX = Number;
                let positionY = Number;

                const startX = e.targetTouches ? e.targetTouches[0].pageX : e.pageX;
                const startY = e.targetTouches ? e.targetTouches[0].pageY : e.pageY;

                if (window.TouchEvent && (e instanceof TouchEvent)) {
                    const rect = e.target.getBoundingClientRect();
                    positionX = e.touches[0].clientX - rect.x;
                    positionY = e.touches[0].clientY - rect.y;
                } else {
                    positionX = e.offsetX;
                    positionY = e.offsetY;
                }


                // console.log("touch", startX, startY, "position", positionX, positionY)
                if (mouseDown) {
                    const centerShiftX = (ImageDisplayerCanvas.width - img.width * ratio) / 2;
                    const centerShiftY = (ImageDisplayerCanvas.height - img.height * ratio) / 2;
                    const ctx = ImageDisplayerCanvas.getContext("2d");
                    ctx.beginPath();
                    // ctx.moveTo(this.imagePosition.x0, this.imagePosition.y0);

                    // for (let i = 0; i < points.length; i++) {
                    //     ctx.lineTo(points[i].x, points[i].y);
                    // }

                    // ctx.fillStyle = this.background;
                    // ctx.fill();
                    const scaledDots = points.map(d => ({ x: (d.x * ratio) + centerShiftX, y: (d.y * ratio) + centerShiftY }));
                    // console.log("scaled", scaledDots)
                    points = [...scaledDots]
                    let mouseUpPosition = {
                        x: clickedPosition.x - positionX,
                        y: clickedPosition.y - positionY
                    }


                    let newDots = [];
                    tempDots.forEach((dot, i) => {
                        if (closestIndex === i) {
                            newDots.push({
                                x: dot.x - mouseUpPosition.x,
                                y: dot.y - mouseUpPosition.y
                            });
                        } else {
                            newDots.push(dot);
                        }
                    });

                    points = [...newDots];
                    drawImageBoundaryScaled(points, CropCanvas, ratio, img);
                    drawImage(img, OriginalCanvas);
                }

            }

            CropCanvas.onmousedown = e => {
                downHandler(e);
            };

            CropCanvas.ontouchstart = e => {
                downHandler(e);
            };

            CropCanvas.onmousemove = e => {
                moveHandler(e);
            };

            CropCanvas.ontouchmove = e => {
                e.preventDefault();
                moveHandler(e);
            };

            CropCanvas.onmouseup = e => {
                mouseDown = false;

            };

            CropCanvas.ontouchend = e => {
                mouseDown = false;

            };
        }

        function eraserTool() {
            selectTool('btn-pen');
            //TODO: Fix on mouse down and last point confilict
            CropCanvas.onmousedown = e => {
                e.preventDefault();
                mouseDown = true;
            };

            CropCanvas.ontouchstart = e => {
                mouseDown = true;
            };


            CropCanvas.onmousemove = e => {
                e.preventDefault()
                if (mouseDown) {
                    mouseMovePenTool(e, ImageDisplayerCanvas, OriginalCanvas, ratio, img, currentScale);
                }
            };

            CropCanvas.ontouchmove = e => {
                e.preventDefault();
                if (mouseDown) {
                    mouseMovePenTool(e, ImageDisplayerCanvas, OriginalCanvas, ratio, img, currentScale);
                }
            };

            CropCanvas.onmouseup = e => {
                e.preventDefault();
                resetLastCoordinates();
                mouseDown = false;
            };

            CropCanvas.ontouchend = e => {
                e.preventDefault();
                resetLastCoordinates();
                mouseDown = false;
            };

        }


        cropperTool();

        buttonPen.onclick = e => {
            eraserTool();
        };

        buttonCrop.onclick = e => {
            cropperTool();
        };
    }

}

